import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export const usePWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    const handleInstalled = () => {
      setDeferredPrompt(null);
      toast.success("Kadhr installed successfully 🎉");
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    window.addEventListener(
      "appinstalled",
      handleInstalled
    );

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );

      window.removeEventListener(
        "appinstalled",
        handleInstalled
      );
    };
  }, []);

  const install = async () => {
    const ua = navigator.userAgent.toLowerCase();

    const isIOS =
      /iphone|ipad|ipod/.test(ua);

    const isFirefox =
      /firefox/.test(ua);

    const isChrome =
      /chrome/.test(ua) &&
      !/edg/.test(ua) &&
      !isFirefox;

    const isEdge =
      /edg/.test(ua);

    if (deferredPrompt) {
      deferredPrompt.prompt();

      const result =
        await deferredPrompt.userChoice;

      if (result.outcome === "accepted") {
        toast.success("Installing Kadhr...");
      }

      setDeferredPrompt(null);
      return;
    }

    if (isIOS) {
      toast.info(
        "Tap Share → Add to Home Screen to install Kadhr."
      );
      return;
    }

    if (isFirefox) {
      toast.info(
        "Firefox doesn't support one-click install. Use browser menu → Add to Home Screen."
      );
      return;
    }

    if (isChrome || isEdge) {
      toast.info(
        "Use browser menu (⋮) → Install Kadhr"
      );
      return;
    }

    toast.info(
      "Use your browser menu to install Kadhr."
    );
  };

  return { install };
};